export default {"src":"/_next/static/media/404_error.644ad4cc.svg","height":150,"width":255,"blurWidth":0,"blurHeight":0};